import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/auto-lease-buyout',
  component: () => import('../../routes/AutoLeaseBuyout.svelte'),
  card: {
    id: 'auto-lease-buyout',
    title: 'Auto Lease Buyout',
    description: 'Decide whether to buy out your car lease early or continue leasing. Compare costs, equity, and net savings.',
    icon: 'car_rental',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/auto-lease-buyout',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Auto Lease Buyout Calculator – Should You Buy Out Your Car Lease?',
    description: 'Free auto lease buyout calculator. Compare the cost of buying out your car lease early versus continuing to the end of the lease term. Includes equity analysis, net savings, and clear recommendations.',
  },
};

export default meta;